<template>
  <div class="login-register-container">
    <!-- 背景装饰 -->
    <div class="bg-decoration bg-circle-1"></div>
    <div class="bg-decoration bg-circle-2"></div>
    <div class="bg-decoration bg-stars"></div>
    
    <div class="login-register-box">
      <!-- 标题和Logo -->
      <div class="auth-header">
        <div class="logo-container">
          <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="logo-image" />
        </div>
        <h2 class="welcome-text">欢迎来到道晗漫画平台</h2>
      </div>

      <div class="tabs">
        <div 
          class="tab" 
          :class="{ active: activeTab === 'login' }" 
          @click="switchTab('login')"
        >
          <span class="tab-icon"><i class="icon-user"></i></span>
          登录
        </div>
        <div 
          class="tab" 
          :class="{ active: activeTab === 'register' }" 
          @click="switchTab('register')"
        >
          <span class="tab-icon"><i class="icon-add-user"></i></span>
          注册
        </div>
      </div>

      <!-- 登录表单 -->
      <div v-if="activeTab === 'login'" class="form">
        <div class="form-group">
          <label for="login-account">
            <i class="icon-user"></i>账号
          </label>
          <input 
            type="text" 
            id="login-account" 
            v-model="loginForm.account" 
            placeholder="请输入账号/手机号"
          >
        </div>
        <div class="form-group">
          <label for="login-password">
            <i class="icon-lock"></i>密码
          </label>
          <input 
            type="password" 
            id="login-password" 
            v-model="loginForm.password" 
            placeholder="请输入密码"
          >
        </div>
        <div class="remember-forgot">
          <label class="remember-me">
            <input type="checkbox" v-model="rememberMe">
            <span>记住我</span>
          </label>
          <a href="#" class="forgot-password" @click.prevent="showForgotModal = true">忘记密码?</a>
        </div>
        <div class="form-actions">
          <button 
            class="btn btn-primary" 
            @click="handleLogin" 
            :disabled="loginLoading"
          >
            <span class="btn-content">
              <i class="icon-login" v-if="!loginLoading"></i>
              <span class="btn-text">{{ loginLoading ? '登录中...' : '登  录' }}</span>
              <div class="btn-loader" v-if="loginLoading"></div>
            </span>
          </button>
        </div>
        <div v-if="loginError" class="error-message">
          <i class="icon-error"></i> {{ loginError }}
        </div>
      </div>

      <!-- 注册表单 -->
      <div v-if="activeTab === 'register'" class="form">
        <div class="form-group">
          <label for="register-username">
            <i class="icon-user"></i>用户名
          </label>
          <input 
            type="text" 
            id="register-username" 
            v-model="registerForm.username" 
            placeholder="请输入手机号码作为用户名"
          >
        </div>
        <div class="form-group">
          <label for="register-password">
            <i class="icon-lock"></i>密码
          </label>
          <input 
            type="password" 
            id="register-password" 
            v-model="registerForm.password" 
            placeholder="请输入密码"
          >
          <div class="password-strength" v-if="registerForm.password">
            <div class="strength-bar" :class="passwordStrength"></div>
            <div class="strength-text">{{ passwordStrengthText }}</div>
          </div>
        </div>
        <div class="form-group">
          <label for="register-confirm-password">
            <i class="icon-lock"></i>确认密码
          </label>
          <input 
            type="password" 
            id="register-confirm-password" 
            v-model="registerForm.confirmPassword" 
            placeholder="请再次输入密码"
          >
        </div>
        <div class="form-actions">
          <button 
            class="btn btn-primary" 
            @click="handleRegister" 
            :disabled="registerLoading"
          >
            <span class="btn-content">
              <i class="icon-register" v-if="!registerLoading"></i>
              <span class="btn-text">{{ registerLoading ? '注册中...' : '立即注册' }}</span>
              <div class="btn-loader" v-if="registerLoading"></div>
            </span>
          </button>
        </div>
        <div v-if="registerError" class="error-message">
          <i class="icon-error"></i> {{ registerError }}
        </div>
      </div>
    </div>

    <!-- 找回密码弹窗 -->
    <div class="forgot-modal" v-if="showForgotModal" @click.self="showForgotModal = false">
      <div class="forgot-panel">
        <button type="button" class="forgot-close" @click="showForgotModal = false">×</button>
        <h3>找回密码</h3>
        <p class="forgot-tip">请填写账号和注册手机号，提交后客服将尽快与您联系处理。</p>
        <input v-model.trim="forgotForm.account" type="text" placeholder="账号或手机号">
        <input v-model.trim="forgotForm.mobile" type="tel" maxlength="11" placeholder="注册手机号">
        <button type="button" class="btn btn-primary" @click="submitForgotPassword" :disabled="forgotSubmitting">
          {{ forgotSubmitting ? '提交中...' : '提交申请' }}
        </button>
        <p class="forgot-message" :class="{ error: forgotError }">{{ forgotMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'

export default {
  name: 'LoginRegister',
  data() {
    return {
      activeTab: 'login', // 当前激活的标签页：login 或 register
      loginForm: {
        account: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      loginLoading: false,
      registerLoading: false,
      loginError: '',
      registerError: '',
      redirectUrl: '/', // 登录/注册成功后的跳转地址
      rememberMe: false,
      showForgotModal: false,
      forgotForm: {
        account: '',
        mobile: ''
      },
      forgotSubmitting: false,
      forgotMessage: '',
      forgotError: false
    }
  },
  created() {
    // 检查URL参数，切换到相应的标签页
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    if (tab === 'register') {
      this.activeTab = 'register';
    }
    
    // 获取重定向URL
    const redirect = urlParams.get('redirect');
    if (redirect) {
      this.redirectUrl = redirect;
    }
  },
  computed: {
    // 计算密码强度
    passwordStrength() {
      if (!this.registerForm.password) return '';
      
      const length = this.registerForm.password.length;
      const hasLetters = /[a-zA-Z]/.test(this.registerForm.password);
      const hasNumbers = /\d/.test(this.registerForm.password);
      const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(this.registerForm.password);
      
      if (length < 6) return 'weak';
      if (length >= 8 && hasLetters && hasNumbers && hasSpecial) return 'strong';
      if (length >= 6 && ((hasLetters && hasNumbers) || (hasLetters && hasSpecial) || (hasNumbers && hasSpecial))) return 'medium';
      return 'weak';
    },
    
    // 密码强度文本
    passwordStrengthText() {
      switch(this.passwordStrength) {
        case 'weak': return '弱';
        case 'medium': return '中';
        case 'strong': return '强';
        default: return '';
      }
    }
  },
  methods: {
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab;
      this.loginError = '';
      this.registerError = '';
    },
    
    // 处理登录
    async handleLogin() {
      // 清除错误提示
      this.loginError = '';
      
      // 表单验证
      if (!this.loginForm.account) {
        this.loginError = '请输入账号';
        return;
      }
      if (!this.loginForm.password) {
        this.loginError = '请输入密码';
        return;
      }
      
      // 显示加载状态
      this.loginLoading = true;
      
      try {
        // 使用API方法发送登录请求
        const result = await api.login({
          account: this.loginForm.account,
          password: this.loginForm.password
        });
        
        // 登录成功
        console.log('登录成功:', result.data);
        
        // 存储用户信息和token
        localStorage.setItem('userInfo', JSON.stringify(result.data.userinfo));
        localStorage.setItem('token', result.data.userinfo.token);
        
        // 页面跳转
        this.$emit('login-success', result.data.userinfo);
        window.location.href = this.redirectUrl;
      } catch (error) {
        console.error('登录失败:', error);
        this.loginError = error.message || '登录失败，请重试';
      } finally {
        this.loginLoading = false;
      }
    },
    async submitForgotPassword() {
      if (!this.forgotForm.account) {
        this.forgotMessage = '请填写账号或手机号'
        this.forgotError = true
        return
      }
      if (!/^1\d{10}$/.test(this.forgotForm.mobile)) {
        this.forgotMessage = '请填写正确的手机号'
        this.forgotError = true
        return
      }
      this.forgotSubmitting = true
      this.forgotError = false
      this.forgotMessage = ''
      try {
        const res = await api.submitForgotPassword({
          account: this.forgotForm.account,
          mobile: this.forgotForm.mobile
        })
        if (res && res.code === 1) {
          this.forgotMessage = (res && res.msg) || '申请已提交，客服将尽快与您联系处理'
          this.forgotError = false
          setTimeout(() => {
            this.showForgotModal = false
            this.forgotForm.account = ''
            this.forgotForm.mobile = ''
            this.forgotMessage = ''
          }, 2000)
        } else {
          this.forgotMessage = (res && res.msg) || '提交失败'
          this.forgotError = true
        }
      } catch (error) {
        this.forgotMessage = (error && error.message) || '提交失败，请重试'
        this.forgotError = true
      } finally {
        this.forgotSubmitting = false
      }
    },
    
    // 处理注册
    async handleRegister() {
      // 清除错误提示
      this.registerError = '';
      
      // 表单验证
      if (!this.registerForm.username) {
        this.registerError = '请输入用户名';
        return;
      }
      if (!this.registerForm.password) {
        this.registerError = '请输入密码';
        return;
      }
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerError = '两次输入的密码不一致';
        return;
      }
      
      // 显示加载状态
      this.registerLoading = true;
      
      try {
        // 使用API方法发送注册请求
        const result = await api.register({
          username: this.registerForm.username,
          password: this.registerForm.password
        });
        
        // 注册成功
        console.log('注册成功:', result.data);
        
        // 存储用户信息和token
        localStorage.setItem('userInfo', JSON.stringify(result.data.userinfo));
        localStorage.setItem('token', result.data.userinfo.token);
        
        // 页面跳转
        this.$emit('register-success', result.data.userinfo);
        window.location.href = this.redirectUrl;
      } catch (error) {
        console.error('注册失败:', error);
        this.registerError = error.message || '注册失败，请重试';
      } finally {
        this.registerLoading = false;
      }
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.login-register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background:
    radial-gradient(circle at 20% 14%, rgba(59, 185, 255, 0.2), transparent 30%),
    radial-gradient(circle at 82% 18%, rgba(176, 101, 255, 0.22), transparent 32%),
    linear-gradient(135deg, #f6fbff 0%, #edf4ff 48%, #f7f2ff 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
  font-family: 'Noto Sans SC', sans-serif;
}

/* 背景装饰 */
.bg-decoration {
  position: absolute;
  z-index: 0;
}

.bg-circle-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(55, 190, 255, 0.28) 0%, rgba(56, 125, 255, 0.14) 50%, rgba(37, 99, 235, 0) 70%);
  top: -150px;
  left: -150px;
  border-radius: 50%;
  animation: float 15s infinite alternate ease-in-out;
}

.bg-circle-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(153, 98, 255, 0.28) 0%, rgba(219, 39, 119, 0.08) 50%, rgba(190, 24, 93, 0) 70%);
  bottom: -100px;
  right: -100px;
  border-radius: 50%;
  animation: float 18s infinite alternate-reverse ease-in-out;
}

.bg-stars {
  background-image: radial-gradient(2px 2px at 20px 30px, #ffffff, rgba(0,0,0,0)),
                    radial-gradient(2px 2px at 40px 70px, #ffffff, rgba(0,0,0,0)),
                    radial-gradient(2px 2px at 50px 160px, #ffffff, rgba(0,0,0,0)),
                    radial-gradient(2px 2px at 90px 40px, #ffffff, rgba(0,0,0,0)),
                    radial-gradient(2px 2px at 130px 80px, #ffffff, rgba(0,0,0,0)),
                    radial-gradient(2px 2px at 160px 120px, #ffffff, rgba(0,0,0,0));
  background-repeat: repeat;
  background-size: 200px 200px;
  width: 100%;
  height: 100%;
  opacity: 0.16;
  animation: twinkle 4s infinite alternate ease-in-out;
}

@keyframes float {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(30px, -30px) scale(1.05);
  }
  100% {
    transform: translate(-30px, 30px) scale(0.95);
  }
}

@keyframes twinkle {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.6;
  }
}

.login-register-box {
  width: min(520px, 100%);
  background-color: rgba(255, 255, 255, 0.82);
  border-radius: 28px;
  box-shadow: 0 28px 80px rgba(43, 66, 150, 0.18);
  overflow: hidden;
  padding: 34px;
  position: relative;
  z-index: 1;
  transition: transform 0.3s, box-shadow 0.3s;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(97, 133, 255, 0.18);
}

.login-register-box:hover {
  transform: translateY(-3px);
  box-shadow: 0 34px 88px rgba(43, 66, 150, 0.22);
}

/* 头部样式 */
.auth-header {
  text-align: center;
  margin-bottom: 25px;
}

.logo-container {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}

.logo-image {
  width: 170px;
  height: auto;
  border-radius: 28px;
  box-shadow: 0 18px 42px rgba(74, 112, 255, 0.16);
}

.welcome-text {
  font-size: 22px;
  color: #1f2a4d;
  margin-bottom: 10px;
  font-weight: 900;
}

/* 标签页样式 */
.tabs {
  display: flex;
  margin-bottom: 25px;
  background-color: #edf4ff;
  border-radius: 30px;
  padding: 5px;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(80, 110, 190, 0.08);
}

.tab {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 25px;
  font-weight: 500;
  color: #53617f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab.active {
  color: #fff;
  background: linear-gradient(135deg, #38bdf8 0%, #8b5cf6 100%);
  box-shadow: 0 10px 24px rgba(83, 113, 255, 0.24);
  font-weight: 600;
}

.tab-icon {
  margin-right: 8px;
  font-size: 16px;
}

/* 表单样式 */
.form {
  padding: 10px 0;
}

.form-group {
  margin-bottom: 20px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #24304f;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.form-group label i {
  margin-right: 8px;
  color: #38bdf8;
}

.form-group input {
  width: 100%;
  height: 48px;
  padding: 0 15px;
  border: 1px solid rgba(97, 133, 255, 0.18);
  border-radius: 16px;
  font-size: 15px;
  outline: none;
  transition: all 0.3s;
  background-color: rgba(247, 250, 255, 0.92);
  color: #24304f;
}

.form-group input:focus {
  border-color: #6d8cff;
  box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.18);
  background-color: #fff;
}

.form-group input::placeholder {
  color: #8b98b8;
}

/* 密码强度指示器 */
.password-strength {
  margin-top: 8px;
  height: 4px;
  background-color: rgba(51, 65, 85, 0.5);
  border-radius: 2px;
  overflow: hidden;
}

.strength-bar {
  height: 100%;
  width: 0;
  transition: width 0.3s ease;
}

.strength-bar.weak {
  width: 33%;
  background-color: #ef4444;
}

.strength-bar.medium {
  width: 66%;
  background-color: #f59e0b;
}

.strength-bar.strong {
  width: 100%;
  background-color: #10b981;
}

.strength-text {
  text-align: right;
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

/* 记住我和忘记密码 */
.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.remember-me {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #53617f;
  cursor: pointer;
}

.remember-me input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.forgot-password {
  color: #60a5fa;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}

.forgot-password:hover {
  color: #93c5fd;
  text-decoration: underline;
}

/* 按钮样式 */
.form-actions {
  margin-top: 10px;
}

.btn {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: linear-gradient(135deg, #38bdf8 0%, #8b5cf6 100%);
  color: #fff;
  box-shadow: 0 14px 32px rgba(83, 113, 255, 0.26);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #20a7ef 0%, #7c3aed 100%);
  box-shadow: 0 18px 36px rgba(83, 113, 255, 0.32);
  transform: translateY(-2px);
}

.btn-primary:disabled {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.5) 0%, rgba(139, 92, 246, 0.5) 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.btn-text {
  letter-spacing: 2px;
}

.btn-loader {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s linear infinite;
  margin-left: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 错误信息 */
.error-message {
  color: #ef4444;
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
  background-color: rgba(239, 68, 68, 0.1);
  border-radius: 14px;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-message i {
  margin-right: 8px;
}

/* 图标样式 */
.icon-user:before,
.icon-add-user:before,
.icon-lock:before,
.icon-login:before,
.icon-register:before,
.icon-error:before {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  content: "";
}

.icon-user:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='%2360a5fa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'%3E%3C/path%3E%3Ccircle cx='12' cy='7' r='4'%3E%3C/circle%3E%3C/svg%3E");
}

.icon-add-user:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='%2360a5fa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'%3E%3C/path%3E%3Ccircle cx='8.5' cy='7' r='4'%3E%3C/circle%3E%3Cline x1='20' y1='8' x2='20' y2='14'%3E%3C/line%3E%3Cline x1='23' y1='11' x2='17' y2='11'%3E%3C/line%3E%3C/svg%3E");
}

.icon-lock:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='%2360a5fa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2' ry='2'%3E%3C/rect%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'%3E%3C/path%3E%3C/svg%3E");
}

.icon-login:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4'%3E%3C/path%3E%3Cpolyline points='10 17 15 12 10 7'%3E%3C/polyline%3E%3Cline x1='15' y1='12' x2='3' y2='12'%3E%3C/line%3E%3C/svg%3E");
}

.icon-register:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'%3E%3C/path%3E%3Cpath d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z'%3E%3C/path%3E%3C/svg%3E");
}

.icon-error:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='%23ef4444' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='8' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='16' x2='12.01' y2='16'%3E%3C/line%3E%3C/svg%3E");
}

@media (max-width: 560px) {
  .login-register-container {
    padding: 16px;
    align-items: flex-start;
  }

  .login-register-box {
    padding: 24px;
    border-radius: 22px;
  }

  .logo-image {
    width: 140px;
  }
}

/* ============ 浅色主题文字覆盖（对抗全局深色主题样式） ============ */
.tab {
  color: #53617f !important;
}

.tab.active {
  color: #ffffff !important;
  background: linear-gradient(135deg, #38bdf8 0%, #8b5cf6 100%) !important;
}

.welcome-text {
  color: #1f2a4d !important;
}

.form-group label {
  color: #24304f !important;
}

.remember-me,
.remember-me span {
  color: #53617f !important;
}

.btn-text {
  color: #ffffff !important;
}

.btn {
  border-radius: 16px !important;
}

.strength-text {
  color: #94a3b8 !important;
}

/* 找回密码弹窗 */
.forgot-modal {
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgba(10, 16, 32, 0.62);
  backdrop-filter: blur(6px);
}

.forgot-panel {
  position: relative;
  width: min(420px, 100%);
  padding: 26px 24px 22px;
  border-radius: 18px;
  border: 1px solid rgba(97, 133, 255, 0.2);
  background: #ffffff;
  box-shadow: 0 32px 80px rgba(43, 66, 150, 0.28);
}

.forgot-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  color: #53617f;
  font-size: 20px;
  cursor: pointer;
  background: #f0f4ff;
}

.forgot-panel h3 {
  margin: 0 0 8px;
  color: #1f2a4d;
  font-size: 20px;
  font-weight: 900;
}

.forgot-tip {
  margin: 0 0 16px;
  color: #53617f;
  font-size: 13px;
  line-height: 1.7;
}

.forgot-panel input {
  width: 100%;
  height: 46px;
  margin-bottom: 12px;
  padding: 0 14px;
  border: 1px solid rgba(97, 133, 255, 0.2);
  border-radius: 12px;
  color: #24304f;
  font-size: 15px;
  outline: none;
  background: #f7faff;
}

.forgot-panel input:focus {
  border-color: #6d8cff;
  box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.16);
}

.forgot-panel .btn-primary {
  height: 46px;
  margin-top: 4px;
  border-radius: 12px;
}

.forgot-message {
  margin-top: 10px;
  color: #10b981;
  font-size: 13px;
  text-align: center;
}

.forgot-message.error {
  color: #ef4444;
}
</style> 
